import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import Info from './info';
import { getCommentCounts } from '../../../../../../services/api';

class Recommend extends React.PureComponent {
    static propTypes = {
        data: PropTypes.array,
    };

    state = {
        counts: [],
    };

    async componentDidMount() {
        try {
            const { data } = this.props;
            const docUrl = data.map(item => item.commentUrl);
            const counts = await getCommentCounts(docUrl);

            this.setState({
                counts,
            });
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const { counts } = this.state;
        const { data } = this.props;

        return (
            <div className={styles.recommend}>
                <div className={styles.title}>
                    <h3>为您推荐</h3>
                </div>
                <div className={styles.list_box}>
                    {data.map((item, index) => <Info key={item.id} data={item} count={counts[index]} />)}
                    <div key="noMore" className={styles.no_more}>
                        已显示全部内容
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Recommend);
